/**
 * @desc 导出基线预测
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.saleForecast.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/saleForecast/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
